import DistributionBar from './common/DistributionBar'
import React from 'react'
import SFDistributionBar from './common/SFDistributionBar'
import palette from '../../global/pallete'

interface UsageBarProps {
  usage: number // in percentage
}
const UsageBar: React.FC<UsageBarProps> = ({ usage }) => {
  const distributions = [
    { value: usage, color: palette.colors.primary },
    { value: 100 - usage, color: palette.colors.primary8 }
  ]
  return <SFDistributionBar distributions={distributions} rounded height={14} />
}

export default UsageBar
